import { render } from "@testing-library/react";
import { Table } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

const ViewWorkingHours = ({ fullData }: any) => {
  const [workingHours, setWorkingHours] = useState<any[]>([]);

  // Function to calculate working hours between start and end time
  const calculateWorkingHours = (startTime: string, endTime: string) => {
    if (!startTime || !endTime) return 0;

    const start = dayjs(startTime, "HH:mm:ss");
    const end = dayjs(endTime, "HH:mm:ss");

    // Handle case where end time is next day (e.g., night shift)
    let duration = end.diff(start, "hour", true);
    if (duration < 0) {
      duration += 24; // Add 24 hours if end time is next day
    }

    return Math.round(duration * 100) / 100; // Round to 2 decimal places
  };

  const columns: any = [
    { title: "Shift Name", dataIndex: "shiftName", key: "shiftName" },
    {
      title: "Work Hours",
      key: "workHours",
      render: (record: any) => {
        const hours = calculateWorkingHours(
          record.shiftStartTime,
          record.shiftEndTime
        );
        return hours > 0 ? `${hours} hrs` : "-";
      },
    },
  ];

  useEffect(() => {
    if (fullData) {
      const workHours = fullData.calendarShifts || [];
      setWorkingHours(workHours);
    }
  }, [fullData]);
  return (
    <>
      <div className="mt-2">
        <Table
          dataSource={workingHours}
          columns={columns}
          bordered
          size="middle"
          scroll={{
            x: 1100,
          }}
        />
      </div>
    </>
  );
};
export default ViewWorkingHours;
